<template>
    <section class="map-container">
        <div id="map"></div>
    </section>
</template>

<script>
import { onMounted } from "vue";
import Map from "../services/map";

export default {
    name: 'Map',
    setup() {
        onMounted(() => {
            Map.getMap();
        })
    }
}
</script>

<style lang="scss" >
@import "../css/leaflet.css";
@import "../css/MarkerCluster.css";
@import "../css/MarkerCluster.Default.css";

.map-container {
    height: 300px;
    width: 100%;

    #map {
        height: 100%;
        width: 100%;
    }
}
</style>